import React from "react";
import Main from "../components/main/main";

export default function HomePage() {
  return (
      <Main />
  );
}
